'use strict';
const angular = require('angular');

export class AddressEditComponent {
  /*@ngInject*/
  constructor() {
    let states_us = ["AL", "AK", "AS", "AZ", "AR", "CA", "CO", "CT", "DE", "DC", "FM", "FL", "GA", "GU", "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MH", "MD", "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ", "NM", "NY", "NC", "ND", "MP", "OH", "OK", "OR", "PW", "PA", "PR", "RI", "SC", "SD", "TN", "TX", "UT", "VT", "VI", "VA", "WA", "WV", "WI", "WY"];
    let states_can = ["AB", "BC", "MB", "NB", "NL", "NT", "NS", "NU", "ON", "PE", "QC", "SK", "YT"];

    this.states = [].concat(
      states_us.map(state => {
        return {country: 'United States', state: state}
      }),
      states_can.map(state => {
        return {country: 'Canada', state: state}
      }),
      [{country: 'Other', state: 'XX'}]
    );
  }

  $onInit = function () {
    this.config = this.resolve.config;

    if (this.config.hasOwnProperty("data")) {
      this.address = angular.copy(this.config.data);
    }
  };

  ok() {
    this.close({$value: this.address});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }
}

export default angular.module('conduu.addressEdit', [])
  .component('addressEdit', {
    template: require('./address-edit.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: AddressEditComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/address-edit/address-edit.component.js